import * as React from "react"
import { t } from 'i18next'
import { Pager } from "../../wordpress/types_and_parser/extra_types.mod"
import { Link, LinkProps, RouteComponentProps, withRouter } from "react-router-dom"
import * as H from 'history'
import qs from 'qs'
import { insertUrlParam } from "../../cms/blocks/utils.gen"


type PaginationProps = RouteComponentProps & {
  pager: Pager
  setPage: (page: number) => void
}

export const Pagination = withRouter((props: PaginationProps) => {
  let paginationNumbers = [];
  
  const padPages: number = 3
  let startPage = Math.max(props.pager.current_page - padPages, 1)
  let endPage = Math.min(props.pager.current_page + padPages, props.pager.total_pages)
  let pageNumber = startPage
  
  for (; pageNumber <= endPage; pageNumber++) {
    if (pageNumber == props.pager.current_page) {
      paginationNumbers.push(<li className="pages__item pages__item--current" key={`page-${pageNumber}`}><span className="pages__link pages__link--current">{pageNumber}</span></li>);
    } else if (pageNumber >= 1 && pageNumber <= props.pager.total_pages) {
      const pageUrl: string = paginatedUrl(window.location.pathname, pageNumber, props.location)
      paginationNumbers.push(<li className="pages__item" key={`page-${pageNumber}`}>
        <Link 
          to={pageUrl} 
          className="pages__link" 
          onClick={e => {
            e.preventDefault()
            insertUrlParam('page', pageNumber.toString())
            props.setPage(pageNumber)
          }}
        >
            {pageNumber}
        </Link>
      </li>)
    }
  }

  return props.pager.total_pages > 1 ? (
    <nav className="pagination">
      <div className="pagination__inner container--xl ">
        <ul className="pagination__list">
          <li className="pagination__item pagination__item--prev">
          { linkDisabled(props.pager.current_page > 1 ? false : true)(
            {
              to: paginatedUrl(window.location.pathname, props.pager.current_page - 1, props.location),
              onClick: e => {
                e.preventDefault()
                insertUrlParam('page', (props.pager.current_page - 1).toString())
                props.setPage(props.pager.current_page - 1)
              },
              className: "pagination__button pagination__button--prev link--primary"
            }
          )(t('pagination.previous'))}
          </li>
          <li className="pagination__item pages">
            <ul className="pages__items" >
              {props.pager.current_page > (padPages+1) ?
                <li className="pages__item">
                  <Link 
                    to={paginatedUrl(window.location.pathname, 1, props.location)}
                    onClick={e => {
                      e.preventDefault()
                      insertUrlParam('page', '1')
                      props.setPage(1)
                    }}
                    className="pages__link">
                      1
                  </Link>
                </li>
              : null }
              { props.pager.current_page > (padPages+2) ? 
                <li className="pages__item pages__item--spacer">&hellip;</li>
              : null }
              { paginationNumbers }
              {props.pager.current_page < props.pager.total_pages - (padPages+1) ? 
                <li className="pages__item pages__item--spacer">&hellip;</li>
              : null }
              {props.pager.current_page < props.pager.total_pages - padPages ? 
                <li className="pages__item">
                  <Link 
                    to={paginatedUrl(window.location.pathname, props.pager.total_pages, props.location)} 
                    onClick={e => {
                      e.preventDefault()
                      insertUrlParam('page', (props.pager.current_page + 1).toString())
                      props.setPage(props.pager.current_page + 1)
                    }}
                    className="pages__link"
                  >
                      {props.pager.total_pages}
                  </Link>
                </li>
              : null }
            </ul>
          </li>

          <li className="pagination__item pagination__item--next">
            { linkDisabled(props.pager.current_page < props.pager.total_pages ? false : true)(
              {
                to: paginatedUrl(window.location.pathname, props.pager.current_page + 1, props.location),
                className: "pagination__button pagination__button--next  link--primary",
                onClick: e => {
                  e.preventDefault()
                  insertUrlParam('page', (props.pager.current_page + 1).toString())
                  props.setPage(props.pager.current_page + 1)
                }  
              }
            )(t('pagination.next')) }
          </li>
        </ul>
      </div>
    </nav>
  ) : null

})

export const paginatedUrl: (
  path: string,
  page: number,
  location: H.Location<any>
) => string = (path: string, page: number) => {
  var params = qs.parse(location.search, { ignoreQueryPrefix: true })
  delete params.page
  const search =
    page <= 1 ? qs.stringify(params) : qs.stringify({ ...params, page })
  return `${path}${search.length > 0 ? `?${search}` : ''}`
}

export const linkDisabled: (disabled: boolean) => (props: LinkProps<H.LocationState>) => (label: string) => JSX.Element = (
  (disabled: boolean) => (props: LinkProps<H.LocationState>) => (label: string) => {
    let newProps: LinkProps<H.LocationState> = disabled ? { ...props, to: null, onClick: null, className: `${props.className} disabled` } : props
    return disabled ? <span {...newProps}>{label}</span> : <Link {...newProps}>{label}</Link> 
  }
)